module.exports = __webpack_public_path__ + "img/12P.209990cb.jpg";